import React, { useState, ReactNode } from "react";
import { Modal } from "../../../components/common";
import { TfaVerificationForm } from "../../forms/tfa";

type Props = {
  children: (fn: () => void) => ReactNode;
};

export const TfaModal: React.FC<Props> = (props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { children } = props;

  const actionHandler = () => setIsOpen(true);

  return (
    <>
      <>{children(actionHandler)}</>

      <Modal
        isOpen={isOpen}
        close={() => setIsOpen(false)}
        title="Two-factor verification"
        subtitle="Set up a Google Authenticator, Authy or Duo Mobile on your phone and scan the QR code into your app"
      >
        <TfaVerificationForm closeForm={() => setIsOpen(false)} />
      </Modal>
    </>
  );
};
